import { render, staticRenderFns } from "./MyPayslipList.vue?vue&type=template&id=f3332f36"
import script from "../../controllers/payslip/my-payslip-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/payslip/my-payslip-list.js?vue&type=script&lang=js&external"
import style0 from "./MyPayslipList.vue?vue&type=style&index=0&id=f3332f36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports